/**
 * Secure Token Storage
 * 
 * Uses sessionStorage (cleared on tab close) instead of localStorage for auth tokens.
 * Applies base64 obfuscation so tokens aren't stored as plaintext strings.
 * Non-sensitive preferences (theme, columns, language) remain in localStorage.
 */

const TOKEN_KEY = '_ks_s';
const WALK_AS_KEY = '_ks_wa';
const ORIGINAL_USER_KEY = '_ks_ou';

function encode(value) {
  try {
    return btoa(unescape(encodeURIComponent(value)));
  } catch {
    return value;
  }
}

function decode(value) {
  try {
    return decodeURIComponent(escape(atob(value)));
  } catch {
    return value;
  }
}

export const tokenStore = {
  getToken() {
    const v = sessionStorage.getItem(TOKEN_KEY);
    return v ? decode(v) : null;
  },

  setToken(token) {
    if (token) {
      sessionStorage.setItem(TOKEN_KEY, encode(token));
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
    }
  },

  removeToken() {
    sessionStorage.removeItem(TOKEN_KEY);
  },

  getWalkAsUser() {
    const v = sessionStorage.getItem(WALK_AS_KEY);
    if (!v) return null;
    try { return JSON.parse(decode(v)); } catch { return null; }
  },

  setWalkAsUser(user) {
    if (user) {
      sessionStorage.setItem(WALK_AS_KEY, encode(JSON.stringify(user)));
    } else {
      sessionStorage.removeItem(WALK_AS_KEY);
    }
  },

  getOriginalUser() {
    const v = sessionStorage.getItem(ORIGINAL_USER_KEY);
    if (!v) return null;
    try { return JSON.parse(decode(v)); } catch { return null; }
  },

  setOriginalUser(user) {
    if (user) {
      sessionStorage.setItem(ORIGINAL_USER_KEY, encode(JSON.stringify(user)));
    } else {
      sessionStorage.removeItem(ORIGINAL_USER_KEY);
    }
  },

  clearAll() {
    sessionStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(WALK_AS_KEY);
    sessionStorage.removeItem(ORIGINAL_USER_KEY);
  },
};
